<template>
  <section style="padding:0 15px;">
    <div class="appendix" v-if="attachmentArr.length">
      <div style="color:#d93c37;">* 当前附件 </div>
      <div class="item no-border" v-for="item,i in attachmentArr">
        <div class="attachments-sumary-item">
          <div class="attachments-item">
            <i class="iconfont icon-close" v-if="(hasAuthority && !flowId) || item.canDelete" @click="deleteAppendix(i, item)"></i>
            <i class="iconfont icon-link"></i>
            <file-link :item="item"></file-link>
            <a :href="item.fileUrl" style="margin-left:5px;" target="_blank">
              <el-button size="mini">下载</el-button>
            </a>
          </div>
          <div class="tip" style="padding:5px 0;">* 不设置权限：默认所有人均能查看</div>
          <div class="dep-auth">
            <div class="contact-user-list">
              <div class="user-item" v-for="user,j in depArr[i]">
                <span class="name">{{user.name}}</span>
                <span @click="deleteDeps(i,j)" class="iconfont icon-close1"></span>
              </div>
            </div>
            <el-button type="primary" @click="addDeps(i)" size="mini" icon="el-icon-plus">设置公司/部门权限</el-button>
          </div>
          <div class="user-auth">
            <div class="contact-user-list">
              <div class="user-item" v-for="user,j in selectArr[i]">
                <span class="name">{{user.name}}</span>
                <span @click="deleteUsers(i,j)" class="iconfont icon-close1"></span>
              </div>
            </div>
            <el-button @click="addUsers(i)" type="primary" size="mini" icon="el-icon-plus">设置人员权限</el-button>
          </div>
        </div>

      </div>
    </div>

    <el-upload style="margin-right:5px;" v-for="at,i in atype" :key="i" class="attachments-upload" :before-upload="handleBeforeUpload"
      :action="uploadUrl" multiple :data="{ name:(at=='其他附件(文件命名后上传)'||at=='点击上传')?'':at }" :on-success="handleAvatarSuccess"
      :show-file-list="false">
      <el-button size="small" type="primary" :loading="isUpload">{{at}}</el-button>
    </el-upload>


    <!-- 选择公司/部门 -->
    <div class="pop-room asset-type-pop" v-if="organizationListStatus">
      <a href="javascript:;" @click="organizationListStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-tree style="max-height:400px;overflow-y:auto;" :data="organizationList" show-checkbox :props="organizationProps"
            node-key="id" ref="organizationTree">
          </el-tree>
          <el-button size="mini" @click="organizationSelectSuccess()" type="primary" style="margin:15px 0 0 25px;">确认选择</el-button>
        </el-col>
      </div>
    </div>
  </section>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import FileLink from '@/components/FileLink'
  export default {
    computed: {
      ...mapState({
        userData: state => state.main.userData,
        isMobile: state => state.main.isMobile,
        organization: state => state.main.organization,
        contactSelectArr: state => state.main.contactSelectArr,
      })
    },
    components: {
      FileLink,
    },
    props: ['type', 'summaryData'],
    data() {
      return {
        // 其他相关附件
        otherAttachmentArr: [],
        otherRelateFiles: "",
        isFlowPass: false,

        atype: [],
        hasAuthority: false,
        isUpload: false,
        uploadUrl: axios.defaults.baseURL + '/common/upload',
        attachmentArr: [],

        files: [],

        attachmentType: {
          a_990: ['点击上传'],
        },

        // 设置人员权限
        selectArrIndex: "",
        selectArr: [],

        // 设置部门权限
        depArrIndex: "",
        depArr: [],
        // depIdArr: [],
        organizationListStatus: false,
        organizationList: [],
        organizationProps: {
          children: 'childDepts',
          label: 'name'
        },
        organizationCheck: {},
      }
    },
    mounted() {
      console.log(this.summaryData)
      if (this.summaryData) {
        this.analysisSummary()
      }

      this.organizationList = this.organization[0].childDepts
      this.atype = this.attachmentType['a_' + this.type]
    },
    methods: {
      // 解析会议纪要
      analysisSummary() {
        this.attachmentArr = []
        for (var i = 0; i < this.summaryData.length; i++) {
          let _file = this.summaryData[i]
          this.attachmentArr.push(_file.attachment)
          this.depArr.push(_file.departments)
          this.selectArr.push(_file.users)
        }
      },
      // 上传前回调
      handleBeforeUpload(file) {
        console.log(file)
        this.isUpload = true
      },
      // 上传成功回调
      handleAvatarSuccess(res, file) {
        this.attachmentArr.push(res.vo)
        this.isUpload = false
      },
      // 删除某附件
      deleteAppendix(index, item) {
        this.attachmentArr.splice(index, 1)
      },
      // 组件获取附件IDS
      getAttachments() {
        // {
        //   attachmentId: 0,
        //   depIds: '',
        //   userIds: ''
        // }
        this.files = []
        for (var i = 0; i < this.attachmentArr.length; i++) {
          let file = {
            attachmentId: this.attachmentArr[i].id,
            depIds: (this.depArr[i] && this.depArr[i].length > 0) ? ',' + this.depArr[i].map(item => item.id).join() +
              ',' : '',
            userIds: (this.selectArr[i] && this.selectArr[i].length > 0) ? ',' + this.selectArr[i].map(item => item.id)
              .join() + ',' : '',
          }
          this.files.push(file)
        }

        return this.files
        // return this.attachmentArr.map(item => item.id).join()
      },


      // 设置人员权限
      addUsers(index) {
        this.selectArrIndex = index

        let _sr = []
        _sr = this.selectArr[index] ? this.selectArr[index] : []
        this.$store.commit('set_contactSelectArr', _sr)
        this.$store.commit('set_contactShow', true)
        this.$store.commit('set_contactSingleSelect', false)
      },
      deleteUsers(arrIndex, index) {
        this.selectArr[arrIndex].splice(index, 1)
      },


      // 设置部门
      addDeps(index) {
        this.organizationListStatus = true
        this.depArrIndex = index
        if (this.depArr[this.depArrIndex]) {
          // console.log(this.depIdArr[this.depArrIndex])
          setTimeout(() => {
            this.$refs.organizationTree.setCheckedNodes(this.depArr[this.depArrIndex])
          }, 100)
        }
      },
      // 确认选择公司/部门
      organizationSelectSuccess() {
        this.organizationListStatus = false

        this.$set(this.depArr, this.depArrIndex, this.$refs.organizationTree.getCheckedNodes())
      },
      deleteDeps(arrIndex, index) {
        this.depArr[arrIndex].splice(index, 1)
      },
    },
    watch: {
      contactSelectArr() {
        this.$set(this.selectArr, this.selectArrIndex, this.contactSelectArr)
      },
      summaryData() {
        this.analysisSummary()
      },
      'arr'() {
        this.attachmentArr = this.arr
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/AttachmentsSumary.vue